import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
} from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {
  readonly router = inject(Router);
  readonly auth = inject(AuthService);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    return this.authorize(route);
  }

  async canActivateChild(route: ActivatedRouteSnapshot): Promise<boolean> {
    return this.authorize(route);
  }

  private async authorize(route: ActivatedRouteSnapshot): Promise<boolean> {
    // Wait for auth initialization
    await this.auth.initialize();
    if(this.auth.isLoggedIn() && !(await this.auth.refreshAccess())){
      if(!this.auth.isLoggedIn())await this.router.navigate(['/login']);
      return false;
    }

    // Not logged in
    if (!this.auth.isLoggedIn()) {
      await this.router.navigate(['/login']);
      return false;
    }

    // Role-based access
    // Check every ancestor as well: a lazy child must not bypass its parent.
    const denied = route.pathFromRoot.some(node => {
      const roles = node.data['roles'] as string[] | undefined;
      return roles && !this.auth.hasRole(roles);
    });
    if (denied) {
      await this.router.navigate(['/unauthorized']);
      return false;
    }

    return true;
  }
}
